import { createDebugger } from '@iotize/common/debug';
const prefix = '@iotize/common:tlv';
export const debug = createDebugger(prefix);
